require('./js/bootstrap')
require('jquery-unveil')

function saveIntendedCampaignUrl () {
  const elements = document.querySelectorAll('[data-campaign]')
  Array.from(elements).forEach(element => {
    $(element).click( () => {
        let href = window.location
        if ($(element).attr('href') == null) {
          href = $(element).closest('.card-button-link').attr('href');
          href = href.replace('donate','');
        }

        localStorage.setItem('intendedCampaignUrl', href);
    })
  })

}

$(document).ready(function() {
  $('[data-src]').unveil(200, function () {
    if (this.tagName.toLowerCase() !== 'img') {
      this.style.backgroundImage = `url(${this.dataset.src})`
    }
  })

  saveIntendedCampaignUrl();
});